const ErrorMessagesService = {
	getConvertedVerificationCodeError: (backendErrorCode) => {
		switch (backendErrorCode) {
			case "activationCodeInvalid":
				return "verification_code_page_invalid_code_error";
			case "expiredActivationCode":
				return "verification_code_page_expired_code_error";
			case "activationCodeRetryLimit":
				return "verification_code_page_retry_limit_error";
			default:
				return "verification_code_page_unexpected_error";
		}
	},
	parseVerificationCodeErrorResponse: (errorResponse) => {
		const errors = { codeAttemptsLeft: null, hideCodeEntryControls: false, errorMessage: null };
		if (!errorResponse) {
			return errors;
		}

		if (errorResponse.timesCodeAttempted && errorResponse.codeAttemptLimit) {
			errors.codeAttemptsLeft = Math.max(errorResponse.codeAttemptLimit - errorResponse.timesCodeAttempted, 0);
		}
		if (errors.codeAttemptsLeft === 0) {
			errors.hideCodeEntryControls = true;
			errors.errorMessage = "verification_code_page_retry_limit_error";
		}

		return errors;
	},
	getLoginErrorMapping: (errorCode) => {
		const errorMap = {
			'invalidphone': { 
				field: 'username', 
				message: ["login_page_invalid_email_phone_error"],
				requiresPhoneSetup: true 
			},
			'invalidcredentials': { 
				field: 'onLogin', 
				message: ["login_page_invalid_credentials_error"] 
			},
			'blockedLogin': { 
				field: 'onLogin', 
				message: ["blocked_login_after_unsuccessful_attempts"] 
			},
			'accountTypeMismatch': { 
				field: 'onLogin', 
				message: ["account_type_mismatch"] 
			},
			'rate_limit_reached': { 
				field: 'onLogin', 
				message: ["login_rate_limit_reached"] 
			}
		};
		
		return errorMap[errorCode] || null;
	},
	isSpecialLoginError: (errorCode) => {
		const specialErrors = [
			'noEmail',
			'emailNotverified',
			'invalidConsents',
			'oldConsents'
		];
		return specialErrors.includes(errorCode);
	}
};

export default ErrorMessagesService;
